import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {DateInputComponent} from './date-input.component';
import {FormsModule} from '@angular/forms';
import {TranslocoModule} from '@ngneat/transloco';
import {IneligibilityOverlayModule} from '@blocks/input/ineligibility-overlay/ineligibility-overlay.module';
import {TranslocoLocaleModule} from '@ngneat/transloco-locale';
import {FontSizeModule} from '@shared/directives/font-size/font-size.module';
import {SubmissionGizmoModule} from '@shared/submission-gizmo/submission-gizmo.module';
import {RequiredIndicatorComponent} from '@shared/controls/required-indicator/required-indicator.component';
import {ReadonlyIndicatorComponent} from '@shared/controls/readonly-indicator/readonly-indicator.component';

@NgModule({
  declarations: [DateInputComponent],
  exports: [
    DateInputComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslocoModule,
    TranslocoLocaleModule,
    IneligibilityOverlayModule,
    FontSizeModule,
    SubmissionGizmoModule,
    RequiredIndicatorComponent,
    ReadonlyIndicatorComponent
  ],
  providers: [
    DatePipe
  ]
})
export class DateInputModule { }
